import React, { useRef } from "react";
import {
  makeStyles,
  Typography,
  Popper,
  Grow,
  Paper,
  ClickAwayListener,
  Box,
  Divider,
  InputAdornment,
  Button,
  MenuItem,
  MenuList
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import PerfectScrollbar from "react-perfect-scrollbar";
import InputTextField from "components/input/inputTextField";
import Skeleton from "@material-ui/lab/Skeleton";
import AntSwitch from "components/switch/switch";
import { convertToBigNum } from "lib/generalUtility";
import { getLang } from "app/feature/constants";
import DefaultImg from "assets/img/img-default.png";


const useStyle = makeStyles((theme) => ({
  paper: {
    width: 418
  },
  button: {
    padding: 0,
    minWidth: 0
  },
  perfectScrollbar: {
    height: 200
  }
}));

export default function AssignModulePanelComponent({
  open,
  anchorRef,
  handleClose,
  handleListKeyDown,
  isOpenList,
  productDropdown,
  isFetching,
  value,
  bonanza,
  handleSearch,
  lang
}) {
  const listDropDown = (field, index) => {
    return (
      <Box key={index}>
        <MenuList
          style={{ paddingTop: 0, paddingBottom: 0 }}
          autoFocusItem={isOpenList}
          id="menu-list-grow"
          onClick={() => {
            handleListKeyDown(field)
          }
          }
        >
          <MenuItem>
            <AntSwitch checked={value.find(v => v.id === field.id) ? true : false} />
            <Box>
              <img
                src={field.picture ? field.picture : DefaultImg}
                style={{ width: "35px", height: "35px", marginLeft: '0.8em'}}
                alt={field.id}
              />
            </Box>
            <Box display="grid" p={1}>
              <Typography variant="inherit" noWrap style={{ paddingLeft: "8px" }}>
                {field.name}
              </Typography>
              {bonanza &&
                <Box>
                  <Typography variant="caption" noWrap style={{ paddingLeft: "8px", color: "#D4D7DB" }}>
                    {getLang(lang, "label.CURRENT_POINT")}
                  </Typography>
                  <Typography variant="inherit" noWrap style={{ paddingLeft: "4px" }}>
                    {convertToBigNum(field.point)}
                  </Typography>
                </Box>
              }
            </Box>
          </MenuItem>
        </MenuList>
        {bonanza && <Divider />}
      </Box>
    );

  }
  const textRef = useRef();
  const classes = useStyle();
  return (
    <Popper
      open={open}
      style={{ zIndex: 99 }}
      anchorEl={anchorRef.current}
      role={undefined}
      transition
      disablePortal
      placement="bottom-start"
    >
      {({ TransitionProps, placement }) => (
        <Grow
          {...TransitionProps}
          style={{
            transformOrigin:
              placement === "bottom-start" ? "center top" : "center bottom"
          }}
        >
          <Paper className={classes.paper}>
            <ClickAwayListener onClickAway={handleClose}>
              <Box>
                <Box>
                  <InputTextField
                    variant="filled"
                    inputRef={textRef}
                    size="small"
                    fullWidth
                    InputProps={{
                      endAdornment: (
                        <InputAdornment
                          position="end"
                          style={{ paddingRight: "6px" }}
                        >
                          <Button onClick={() => handleSearch(textRef.current.value)} className={classes.button}>
                            <SearchIcon fontSize="small" />
                          </Button>
                        </InputAdornment>
                      ),
                      style: {
                        backgroundColor: "#ECEFF0"
                      }
                    }}
                    inputProps={{
                      onKeyDown: (e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          handleSearch(textRef.current.value)
                          return false;
                        }
                      },
                      style: {
                        padding: "14px"
                      }
                    }}
                    placeholder={getLang(lang, 'placeholder.SEARCH_PRODUCT')}
                  />
                </Box>
                <Divider />

                <PerfectScrollbar className={classes.perfectScrollbar}>
                  {isFetching ? (
                    <>
                      <Skeleton height={50} variant="text" animation="wave" />
                      <Skeleton height={50} variant="text" animation="wave" />
                      <Skeleton height={50} variant="text" animation="wave" />
                      <Skeleton height={50} variant="text" animation="wave" />
                    </>
                  ) :
                    <>
                      {
                        productDropdown.length > 0 ? productDropdown.map((field, index) => {
                          return listDropDown(field, index)
                        })
                          : <Box py={9} style={{ textAlign: "center" }} >
                            <Typography variant="body1"> {bonanza ? getLang(lang, "paragraph.NO_MODULE_WITH_LOYALTY_POINT") : getLang(lang, "label.NO_MODULE")}</Typography>
                          </Box>
                      }
                    </>
                  }
                </PerfectScrollbar>
              </Box>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  );
}
